import Billing from './billing.i18n';

export default Billing
export { Billing as Base }